import React, {useEffect} from 'react';
import './Testimonials.css';
import AVTR1 from '../../assets/avatar5.jpg';
import Aos from 'aos';
import "aos/dist/aos.css";

// import Swiper core and required modules
import { Navigation, Pagination } from 'swiper';

import { Swiper, SwiperSlide } from 'swiper/react';

//import Swiper Styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

const data = [
  {
    avatar: AVTR1,
    name: 'Precious Okosun',
    review: 'Elton is very good at what he does, always eager to learn and improve',
  }
  
]

const Testimonials = () => {
  useEffect(() => {
    Aos.init({duration: 1000});
  },[]);

  return (
    <section id="testimonials"> 
      <h5 data-aos="fade-in"> Review from Clients </h5> 
      <h2 data-aos="fade-in"> Testimonials </h2>

      <Swiper className='container testimonials__container' data-aos="zoom-in"
      //install swiper modules
      modules={[ Navigation, Pagination]}
      spaceBetween={40}
      slidesPerView={1}
      navigation={{ nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev'}}
      pagination={{ clickable: true}}>
        {
          data.map(({avatar, name, review}, index) => {
            return (
              <SwiperSlide key={index} className='testimonial'>
          <div className='client__avatar'>
            <img src={avatar} alt={name} />
            </div>
            <h5 className='client__name'> {name} </h5>
            <small className='client__review'>
            {review}
            </small>
        </SwiperSlide>
            )
          })
        }
      </Swiper>
    </section>
  )
}

export default Testimonials;